'use client';
import { getCallCodeFromReportV3 } from '@dte/otw-azure-functions/src/common/reports/customerReport/symptomsToCallCodeV3/getCallCodeFromReport';
import { atom, useAtomValue } from 'jotai';
import type { ReactNode } from 'react';
import { premiseMasterDataAtom } from '../premises/(premiseId)/PremiseMasterDataProvider';
import { workingDraftReportWithCurrentStepAtom } from './workingDraftReportWithCurrentStepAtom';

export const projectedCallCodeAtom = atom((get) => {
	const report = get(workingDraftReportWithCurrentStepAtom);
	const masterData = get(premiseMasterDataAtom);
	return getCallCodeFromReportV3(report, masterData) ?? '(unknown)';
});

export function DraftReportCallCode(): ReactNode {
	const callCode = useAtomValue(projectedCallCodeAtom);
	return <>Call code: {callCode}</>;
}
